//export const ERROR_PAGE_ID = 2127
//export const REDIRECT_PAGE_ID = 2124
export const FAQ_PAGE_ID = 2111
export const SLIDES_PAGE_ID = 2128
export const COURSE_NAV_ID = 2242
export const EVENT_NAV_ID = 2227
export const FOOTER_NAV_ID = 2301
